import request from '@/utils/request'

// 查询APP版本列表
export function listAppVersion(query) {
  return request({
    url: '/biz/app-version/list',
    method: 'get',
    params: query
  })
}

// 查询APP版本分页
export function pageAppVersion(query) {
  return request({
    url: '/biz/app-version/page',
    method: 'get',
    params: query
  })
}

// 查询APP版本详情
export function getAppVersion(data) {
  return request({
    url: '/biz/app-version/detail',
    method: 'get',
    params: data
  })
}

// 新增APP版本
export function addAppVersion(data) {
  return request({
    url: '/biz/app-version/add',
    method: 'post',
    data: data
  })
}

// 修改APP版本
export function updateAppVersion(data) {
  return request({
    url: '/biz/app-version/edit',
    method: 'post',
    data: data
  })
}

// 删除APP版本
export function delAppVersion(data) {
  return request({
    url: '/biz/app-version/delete',
    method: 'post',
    data: data
  })
}
